<template>
    <section class="environments">
        <scroll-to-me @trigger-animate="toggleEnvironmentsTitle">
            <h3 data-anime="fade-up"
                :class="{animate: showTitle}"
                class="environments__title">Inspire-se</h3>
        </scroll-to-me>
        <scroll-to-me @trigger-animate="toggleEnvironmentsSubtitle">
            <h2 class="environments__subtitle"
                data-anime="fade-up"
                :class="{animate: showSubtitle}">{{$root.commonTexts['home.ambiente.titulo']}}</h2>
        </scroll-to-me>
        <scroll-to-me @trigger-animate="toggleEnvironmentsText">
            <p class="environments__text" data-anime="fade-up"
               :class="{animate: showText}">{{$root.commonTexts['home.ambiente.texto']}}</p>
        </scroll-to-me>

        <scroll-to-me @trigger-animate="toggleEnvironments">
            <div v-if="ambientes.length" class="carousel-container" data-anime="fade-up"
                 :class="{animate: showEnvironments}">
                <swiper :options="swiperOption2">
                    <swiper-slide v-for="(ambiente, index) in ambientes" class="slide-item" :key="ambiente.id">
                        <div v-if="ambiente.images.length" class="item">
                            <lazy-image :width="width"
                                        :height="height" :image="ambiente.images[0]" />
                            <div class="item__content">
                                <div @click="openModal(index)"  class="arrow-wrapper">
                                    <div class="arrow1"></div>
                                    <div class="arrow2"></div>
                                    <div class="arrow3"></div>
                                    <div class="arrow4"></div>
                                    <img class="item__content__img" src="@/assets/icons/lupa.svg" alt="">
                                    <p class="item__content__text">{{ambiente.name}}</p>
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                    <div class="swiper-button-prev mobile" slot="button-prev"></div>
                    <div class="swiper-button-next mobile" slot="button-next"></div>
                </swiper>
            </div>
        </scroll-to-me>

        <div class="modal"
             @click="outsideClick"
             :class="{active: toggleModal}">
            <div class="modal-container"
                 v-if="ambientes.length">
                <div class="modal__image">
                    <div class="modal__image__img">
                        <lazy-image bg-mode :image="ambientes[modalOffset].images[imageOffset]" />
                    </div>
                    <div class="modal__image__list" v-if="ambientes.length">
                        <div class="modal__image__list__item" v-for="(image, index) in ambientes[modalOffset].images" :key="image.id">
                            <lazy-image @click.native="imageOffset = index"
                                 v-if="image.permalink !== null"
                                 :class="{active: imageOffset === index}"
                                 :image="image"/>
                        </div>
                    </div>
                </div>
                <div class="modal__content" v-if="ambientes.length">
                    <span v-if="0" class="modal__flag">lançamento</span>
                    <h2 class="modal__content__title">{{ambientes[modalOffset].name}}</h2>
                    <h3>Produtos do ambiente</h3>
                    <vue-markdown :source="ambientes[modalOffset].description" class="modal__content__desc"></vue-markdown>
                    <router-link @click.native="enableScroll"
                                 :to="{ name: 'produto', params: { id: product.friendly_url || product.id }}"
                                 class="send_btn env-btn"
                                 v-for="product in ambientes[modalOffset].products" :key="product.id">
                        {{product.name}}
                    </router-link>
                </div>
                <div class="modal__close">
                    <img @click="toggleModal = false" src="@/assets/icons/close.svg" alt="">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import 'swiper/dist/css/swiper.css';
    import {swiper, swiperSlide} from 'vue-awesome-swiper';
    import ScrollToMe from "../../Shared/ScrollToMe";
    import VueMarkdown from 'vue-markdown';
    import LazyImage from "../../Shared/LazyImage";

    export default {
        name: "HomeEnvironments",
        data() {
            return {
                swiperOption2: {
                    breakpoints: {
                        // when window width is >= 320px
                        300: {
                            slidesPerView: 1,
                            spaceBetween: 15
                        },
                        // when window width is >= 480px
                        767: {
                            slidesPerView: 1,
                            spaceBetween: 15
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 5
                        },
                        // when window width is >= 640px
                        1025: {
                            slidesPerView: 2,
                            spaceBetween: 15
                        }
                    },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false
                    },
                    speed: 800,
                    slidesPerView: 3,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                ambientes: [],
                width: '630px',
                height: '600px',
                showTitle: false,
                showSubtitle: false,
                showText: false,
                showEnvironments: false,
                toggleModal: false,
                modalOffset: 0,
                imageOffset: 0,
                myBody: '',
                mobile: window.matchMedia('(max-width:767px').matches
            }
        },
        watch: {
            toggleModal() {
                this.toggleModal ? this.disableScroll() : this.enableScroll();
            },
        },
        methods: {
            disableScroll() {
                this.myBody.style.overflowY = 'hidden';
            },
            enableScroll() {
                this.myBody.style.overflowY = 'auto';
            },
            openModal(index) {
                this.imageOffset = 0;
                this.toggleModal = !this.toggleModal;
                this.modalOffset = index;
            },
            outsideClick({target, currentTarget}) {
                target === currentTarget ? this.toggleModal = false : '';
            },
            fetchAmbientes() {
                axios.get('/productdesta')
                    .then(r => {
                        this.ambientes = r.data.data;
                    })
            },
            toggleEnvironmentsTitle() {
                this.showTitle = true;
            },
            toggleEnvironmentsSubtitle() {
                this.showSubtitle = true;
            },
            toggleEnvironmentsText() {
                this.showText = true;
            },
            toggleEnvironments() {
                this.showEnvironments = true;
            }
        },
        mounted() {
            this.fetchAmbientes();
            this.myBody = document.querySelector('body');

            if(this.mobile) {
                this.width = '300px';
                this.height = '300px';
            }

        },
        components: {
            swiper,
            swiperSlide,
            ScrollToMe,
            VueMarkdown,
            LazyImage
        }
    }
</script>

<style lang="scss" scoped>
    .env-btn {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.875rem;
    }

    .environments {
        margin-top: 80px;

        &__title {
            text-align: center;
            font-family: 'Open Sans';
            font-weight: 400;
            font-size: 1.125rem;
            margin-bottom: 10px;
        }

        &__subtitle {
            margin-bottom: 20px;
            font-family: 'HelveticaNeue', Arial, sans-serif;
            font-weight: 500;
            font-size: 2rem;
            text-align: center;
        }

        &__text {
            font-family: 'Open Sans';
            font-weight: 400;
            max-width: 1140px;
            margin: 0 auto;
            padding: 0 15px;
            font-size: 1rem;
            text-align: center;
        }
    }

    .carousel-container {
        margin-top: 60px;
        width: 100%;
    }

    .item {
        height: 600px;
        margin: 0 2px;
        position: relative;
        background-size: cover;
        background-position: center center;

        &__content {
            display: block;
            opacity: 0;
            position: absolute;
            left: 50%;
            top: 45%;
            transform: translate3d(-50%, -30%, 0);
            padding: 30px 40px;
            background: rgba(0, 0, 0, .8);
            width: 340px;
            transition: all .3s;

            &__img {
                margin: 0 auto 20px auto;
            }

            &__text {
                font-family: HelveticaNeueLight, Arial, sans-serif;
                font-size: 1.25rem;
                max-width: 140px;
                margin: 0 auto;
                text-align: center;
                color: #fff;
            }
        }
    }

    .item:hover .item__content {
        opacity: 1;
        transform: translate3d(-50%, -45%, 0);
        cursor: pointer;
    }

    .arrow-wrapper {
        padding: 70px 0px;
        position: relative;
    }

    .modal {
        opacity: 0;
        transition: all .3s;
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background: rgba(0, 0, 0, .5);
        z-index: 100;

        &.active {
            opacity: 1;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .modal__close {
            position: absolute;
            right: 20px;
            top: 20px;
            cursor: pointer;
        }
    }

    .modal-container {
        opacity: 1;
        margin: 0 auto;
        width: 1140px;
        height: 720px;
        background: #fff;
        z-index: 1;
        display: flex;
        padding: 40px;
        border-radius: 4px;
        position: relative;
    }

    .modal__image {
        width: 560px;
        height: 640px;
        flex-shrink: 0;

        &__img {
            width: 560px;
            height: 560px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            position: relative;
        }

        img {
            width: 100%;
        }

        &__list {
            margin-top: 30px;
            display: flex;
            align-items: center;
            overflow: auto;

            &__item {
                width: 80px !important;
                height: 60px;
                opacity: 0.7;
                cursor: pointer;
                margin-right: 15px;
                position: relative;

                &:hover {
                    opacity: 1;
                }

                &.active {
                    opacity: 1;
                }
            }
        }
    }

    .modal__content {
        margin-left: 40px;
        width: 100%;
        overflow: auto;

        &__title {
            font-family: HelveticaNeue, Arial, sans-serif;
            font-weight: 500;
        }

        h3 {
            font-family: HelveticaNeue, Arial, sans-serif;
            font-weight: 500;
            color: #aaa;
            margin-top: 20px;
        }

        &__desc {
            font-family: HelveticaNeue, Arial, sans-serif;
            font-weight: 500;
            color: #2b2b2b;
            margin-top: 10px;
        }
    }

    .modal__flag {
        display: block;
        text-transform: lowercase;
        font-family: "Open Sans";
        font-size: 0.875rem;
        border: 1px solid #2b2b2b;
        padding: 2px 5px;
        margin-bottom: 20px;
        text-align: center;
        width: 120px;
    }

    @media only screen and (max-width: 1440px) {
        .item {
            height: 420px;
        }

        .item__content {
            width: 300px;
            padding: 15px 25px;
        }
    }

    @media only screen and(max-width: 1200px) {
        .modal-container {
            width: 820px;
            height: auto;
            flex-direction: column;
        }

        .modal .modal__close {
            right: 12px;
            top: 12px;
        }

        .modal__content {
            margin-left: 0;
            margin-top: 40px;
        }

        .modal__image {
            width: 100%;
            height: 440px;
            flex-shrink: 0;
            margin-bottom: 20px;

            &__img {
                width: 100%;
                height: 360px;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
                margin-right: 20px;
                border-radius: 4px;
            }

            img {
                width: 100%;
            }

            &__list {
                max-width: 100%;
                margin-top: 30px;
                display: flex;
                justify-content: space-between;

                &__item {
                    width: 80px !important;
                    height: 80px;
                }
            }
        }
    }

    @media only screen and (max-width: 768px) {
        .item__content {
            width: 300px;
            padding: 30px 30px;
        }

        .modal-container {
            width: 680px;
            height: auto;
            flex-direction: column;
        }

        .modal .modal__close {
            right: 12px;
            top: 12px;
        }

        .modal__content {
            margin-left: 0;
            margin-top: 30px;
        }

        .modal__image {
            width: 100%;
            height: 440px;
            flex-shrink: 0;
            margin-bottom: 20px;

            &__img {
                width: 100%;
                height: 360px;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
                margin-right: 20px;
            }

            img {
                width: 100%;
            }

            &__list {
                max-width: 100%;
                margin-top: 30px;
                display: flex;
                justify-content: space-between;

                &__item {
                    width: 60px !important;
                    height: 60px;
                }
            }
        }
    }

    @media only screen and(max-width: 767px) {
        .item {
            height: 380px;
            max-width: 300px;
            margin: 5px auto;

            img {
                object-fit: cover;
                height: 300px;
            }
        }

        .item__content {
            width: 240px;
            height: auto;
            padding: 15px 15px;
            transform: translate3d(-50%, 100%, 0);
        }

        .item:hover .item__content {
            opacity: 1;
            transform: translate3d(-50%, -60%, 0);
            cursor: pointer;
        }

        .item__content__img {
            width: 30px;
        }

        .item__content__text {
            font-size: 0.95rem;
        }

        .environments__text {
            font-size: 0.875rem;
            text-align: center;
        }

        .arrow-wrapper {
            padding: 50px 0;
        }

        .modal-container {
            width: calc(100% - 30px);
            height: 500px;
            overflow: auto;
            flex-direction: column;
            padding: 50px 13px 20px 13px;
        }

        .modal .modal__close {
            max-width: 13px;
            right: 12px;
            top: 12px;
        }

        .modal__content {
            margin-left: 0;
            margin-top: 0px;
            padding: 0 10px;
        }

        .modal__flag {
            margin-bottom: 10px;
        }

        .modal__image {
            width: 100%;
            flex-shrink: 0;
            margin-bottom: 10px;
            height: auto;

            &__img {
                width: 100%;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
                margin-right: 20px;
                height: 200px;
                border-radius: 4px;
            }

            img {
                width: 100%;
            }

            &__list {
                max-width: 100%;
                margin-top: 15px;
                display: flex;
                justify-content: normal;
                flex-wrap: wrap;

                &__item {
                    width: 39px !important;
                    height: 39px;
                    margin: 0 3px 12px 3px;
                }
            }
        }

        .modal__content__title {
            font-size: 1.375rem;
        }

        .modal__content h3 {
            margin-top: 10px;
            font-size: 1rem;
        }

        .modal__content__desc {
            white-space: pre-line;
            font-size: 0.875rem;
            color: #4d4d4d;
            line-height: 24px;
            padding-right: 10px;
        }
    }
</style>